"use client";

import { ReactNode } from "react";

export default function SectionCard({
  title,
  icon,
  children,
}: {
  title: string;
  icon?: string;
  children: ReactNode;
}) {
  return (
    <div className="mb-8 rounded-xl border border-white/10 bg-white/5 backdrop-blur-md p-6 shadow-lg">
      <h2 className="mb-4 flex items-center gap-2 text-xl font-semibold text-white">
        {icon && <span>{icon}</span>}
        {title}
      </h2>

      <div className="space-y-4 text-sm leading-relaxed text-gray-200">
        {children}
      </div>
    </div>
  );
}
